import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { installSpanishValidationMessages } from './lib/validation/error-map';
import './styles/index.css';

// Before anything renders, so the first form error is already in Spanish.
installSpanishValidationMessages();

const container = document.getElementById('root');
if (!container) throw new Error('Root container #root not found in index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
